import styles from "./index.module.scss";
import { MoreSvg } from "@/assets/icons";
import { 
  MoreMenu,
} from "@/components";
import clsx from "clsx";
import { useState, useRef } from "react";

const MoreButton = () => {
  const [menuVisible, setMenuVisible] = useState<boolean>(false);
  const timeoutIdRef = useRef<any>();

  const handleMouseEnter = () => {
    clearTimeout(timeoutIdRef.current);
    setMenuVisible(true);
  }

  const handleMouseLeave = () => {
    timeoutIdRef.current = setTimeout(() => {
      setMenuVisible(false);
    }, 500);
  }

  return (
    <button
      className={clsx(
        styles["more_button"],
        "circle_button"
      )}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <MoreSvg></MoreSvg>

      {menuVisible && (
        <div
          className={styles["more_menu_wrapper"]}
        >
          <MoreMenu></MoreMenu>
        </div>  
      )}
    </button>
  )
}

export default MoreButton;